export default [
  { value: 'Undefined', label: 'Undefined' },
  { value: 'Suburban', label: 'Suburban' },
  { value: 'Urban', label: 'Urban' },
  { value: 'Rural', label: 'Rural' },
];
